<script>
import Layout from '@layouts/main'

export default {
  name: 'Account',
  components: {
    Layout,
  },
  computed: {
    settings() {
      return this.$store.state.userSettings.userSettings
    },
    muteCheckboxInit() {
      const userSettings=this.$store.state.userSettings.userSettings
      let res=undefined
      if(userSettings.userSettingMuteAllNotification === undefined){
        res=false
      }else{
        res=(userSettings.userSettingMuteAllNotification.localeCompare('true')===0?true:false)
      }
      return res
    }
  },
  methods: {
    muteChkBoxOnChange(event){
      console.log('change'+event)
      this.$store.dispatch('userSettings/setUserSettings', { key:'userSettingMuteAllNotification', value: event })
    },
    goBack() {
      this.$router.go(-1)
    },
    changePassword() {
      this.$router.push({ name: 'password' })
    },
    changeSettings(key, value) {
      this.$store.dispatch('userSettings/setUserSettings', { key, value })
    },
  },
}
</script>

<template>
  <Layout>
    <v-layout
    row
    style="background: white">
    <v-flex
    :class="$style.sdTable"
    md2 >{{ $t('label__units_of_measurement') }}</v-flex>
    <v-flex
    xs8 >
    <v-radio-group
    :input-value="settings['unitsMeasurement']"
    color="primary"
    @change="changeSettings('unitsMeasurement', $event)">
    <v-radio
    :label="$t('label__metric_system')"
    value="ms"
    />
    <v-radio
    :label="$t('label__us_system')"
    value="us"
    />
    <v-radio
    :label="$t('label__imperial_system')"
    value="is"
    />
  </v-radio-group>
</v-flex>
</v-layout>
<v-layout
row
style="background: white">
<v-flex
:class="$style.sdTable"
md2 >{{ $t('label__battery_charge_display') }}</v-flex>
<v-flex
xs8 >
<v-radio-group
:input-value="settings['batteryChargeDisplay']"
color="primary"
@change="changeSettings('batteryChargeDisplay', $event)">
<v-radio
:label="$t('label__volts')"
value="volts"
/>
<v-radio
:label="$t('label__percentage')"
value="percentage"
/>
</v-radio-group>
</v-flex>
</v-layout>
<v-layout
row
style="background: white">
<v-flex
:class="$style.sdTable"
md2
>
{{ $t('label__user_setting_mute_all_notification') }}
</v-flex>
<v-flex
xs8
>
  <v-checkbox
    :input-value="muteCheckboxInit"
    @change="changeSettings('userSettingMuteAllNotification', $event)"
  ></v-checkbox>
</v-flex>
</v-layout>
<v-layout style="padding-top: 20px">
  <v-btn
  color="primary"
  @click="changePassword()"
  >
  {{ $t('buttons__change_password') }}
</v-btn>
</v-layout>
<v-layout>
  <v-btn
  flat
  color="primary"
  @click="goBack()"
  >
  {{ $t('label__go_back') }}
</v-btn>
</v-layout>
</Layout>
</template>


<style lang="scss" module>
@import '@design';
.sdTable {
  padding-top: 20px;
  text-align: center;
}
</style>
